import { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { twMerge } from "tailwind-merge";

function SubDepartmentSideScroll({ subDepartments, viewSubDepartmentDetails }) {
  const { id } = useParams();
  const selectedCardRef = useRef(null);

  useEffect(() => {
    selectedCardRef.current?.scrollIntoView({
      block: "nearest",
      behavior: "smooth",
    });
  }, [id, subDepartments.length]);

  return (
    <div className="w-full h-screen p-2 border-[1px] border-gray-200 rounded-lg overflow-y-auto scrollbar-thumb-gray-400 scrollbar-thin scrollbar-track-gray-200">
      {subDepartments.map((subDepartment, index) => {
        const selected = String(id) === String(subDepartment.id);
        return (
          <div
            ref={selected ? selectedCardRef : null}
            className={twMerge(
              "border px-2 py-3 cursor-pointer border-gray-200 transition-colors",
              selected ? "bg-gray-200" : "hover:bg-gray-100"
            )}
            key={subDepartment.id || index}
            onClick={() => viewSubDepartmentDetails(subDepartment.id)}
          >
            <div className="text-sm font-semibold text-gray-700 truncate">
              {subDepartment.name}
            </div>
            <div className="mt-1 text-xs font-medium text-gray-500">
              {subDepartment.statusName}
            </div>
          </div>
        );
      })}
      {subDepartments.length < 1 ? (
        <div className="p-4 text-sm text-gray-500">No Sub Departments found</div>
      ) : null}
    </div>
  );
}

export default SubDepartmentSideScroll;
